// libs
import { styled } from '@nykaa/ui-components';

import OverlaySheetBase from 'shared/components/OverlaySheet';
import { BASE_FONT } from 'shared/styles/base';

export const OverlaySheet = styled(OverlaySheetBase)`
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  background: transparent;
  color: ${({ theme }) => theme.colors.textPrimary};
  border-radius: ${({ theme }) => theme.borders.radiusNone};
  top: initial;

  & .fixed-content {
    position: relative;
    width: 100%;
    max-height: 90vh;
    overflow: scroll;
    background: ${({ theme }) => theme.colors.overlayBg};
    border-radius: ${({ theme }) => `${theme.borders.radius40} ${theme.borders.radius40} 0 0`};
    box-shadow: ${({ theme }) => theme.elevations.shadow400};
    z-index: 7;

    li{
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  }

  & .content-wrapper {
    padding: ${({ theme }) => `0 ${theme.spacing.spacing100}`};

    p,
    h1,
    h3 {
      font-family: ${BASE_FONT};
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  }

  & .close-btn {
    position: absolute;
    right: 10px;
    top: 10px;
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
